var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"gap":"15px"},attrs:{"justify":"center"}},_vm._l((_vm.projects),function(project,index){return _c('UniqueProject',_vm._b({key:'project_' + index},'UniqueProject',project,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }